// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3-goc","inner":"Card_inner__1arQ7","text":"Card_text__1LN6m","link":"Card_link__1bHFt","active":"Card_active__sJCAt","right":"Card_right__3_ajq"};